import cn from "classnames";
import { formatNumber } from "helpers/system";
import React from "react";

export default function InvolvementAnalysis(props) {
    const { data } = props;

    const renderDataTable = (tableData, mainData) => {
        return (
            <div>
                <table className="a-report__table">
                    <thead>
                        <tr>
                            <th className="a-report__table--noborder-left a-report__table--noborder-top">
                                По компании
                            </th>
                            {data.header.map((item, i, arr) => {
                                const isLast = arr.length - 1 === i;
                                return (
                                    <th
                                        key={i}
                                        className={cn("a-report__table--noborder-top", {
                                            "a-report__table--noborder-right font-weight-bold": isLast,
                                        })}
                                    >
                                        {item.week}
                                        <br />
                                        <small className={isLast ? "font-weight-bold" : ""}>{item.period}</small>
                                    </th>
                                );
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {mainData && (
                            <tr>
                                <td className="a-report__table--noborder-left">
                                    Соотношение всех ТС к ТС с активными трекерами
                                </td>
                                {tableData.activeCarsCount.map((item, i, arr) => (
                                    <td
                                        key={i}
                                        className={arr.length - 1 === i ? "a-report__table--noborder-right" : ""}
                                    >
                                        {item.value}
                                        {!!item.percent && (
                                            <>
                                                <br />
                                                <small
                                                    className={
                                                        item.percent < 0
                                                            ? "a-report__table--red"
                                                            : "a-report__table--green"
                                                    }
                                                >
                                                    (
                                                    {formatNumber(item.percent / 100, {
                                                        style: "percent",
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    })}
                                                    )
                                                </small>
                                            </>
                                        )}
                                    </td>
                                ))}
                            </tr>
                        )}
                        <tr>
                            <td className="a-report__table--noborder-left">Своевременость создания заявок</td>
                            {tableData.bidsCreatedOnTimePercent.map((item, i, arr) => (
                                <td key={i} className={arr.length - 1 === i ? "a-report__table--noborder-right" : ""}>
                                    {item.value}
                                    {!!item.percent && (
                                        <>
                                            <br />
                                            <small
                                                className={
                                                    item.percent < 0 ? "a-report__table--red" : "a-report__table--green"
                                                }
                                            >
                                                (
                                                {formatNumber(item.percent / 100, {
                                                    style: "percent",
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                })}
                                                )
                                            </small>
                                        </>
                                    )}
                                </td>
                            ))}
                        </tr>
                        <tr>
                            <td className="a-report__table--noborder-left">Незакрытые заявки и неучтенные заявки</td>
                            {tableData.notClosedBidsCount.map((item, i, arr) => (
                                <td key={i} className={arr.length - 1 === i ? "a-report__table--noborder-right" : ""}>
                                    {item.value}
                                    {!!item.percent && (
                                        <>
                                            <br />
                                            <small
                                                className={
                                                    item.percent < 0 ? "a-report__table--red" : "a-report__table--green"
                                                }
                                            >
                                                (
                                                {formatNumber(item.percent / 100, {
                                                    style: "percent",
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                })}
                                                )
                                            </small>
                                        </>
                                    )}
                                </td>
                            ))}
                        </tr>
                        <tr>
                            <td className="a-report__table--noborder-left">
                                Процент использования приложения водителями
                            </td>
                            {tableData.driverAppUsageAveragePercent.map((item, i, arr) => (
                                <td key={i} className={arr.length - 1 === i ? "a-report__table--noborder-right" : ""}>
                                    {item.value}
                                    {!!item.percent && (
                                        <>
                                            <br />
                                            <small
                                                className={
                                                    item.percent < 0 ? "a-report__table--red" : "a-report__table--green"
                                                }
                                            >
                                                (
                                                {formatNumber(item.percent / 100, {
                                                    style: "percent",
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                })}
                                                )
                                            </small>
                                        </>
                                    )}
                                </td>
                            ))}
                        </tr>
                        {/* <tr>
                            <td className="a-report__table--noborder-left">Работа с планированием</td>
                            {tableData.planningOpensPercent.map((item, i, arr) => (
                                <td key={i} className={arr.length - 1 === i ? "a-report__table--noborder-right" : ""}>
                                    {item.value}
                                    {!!item.percent && (
                                        <>
                                            <br />
                                            <small
                                                className={
                                                    item.percent < 0 ? "a-report__table--red" : "a-report__table--green"
                                                }
                                            >
                                                (
                                                {formatNumber(item.percent / 100, {
                                                    style: "percent",
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                })}
                                                )
                                            </small>
                                        </>
                                    )}
                                </td>
                            ))}
                        </tr> */}
                    </tbody>
                </table>
            </div>
        );
    };

    return (
        <div className="pb-2">
            <div className="a-report__text-block">
                <div className="a-report__title">Развитие цифровой среды: анализ вовлеченности и эффективности</div>
                <div className="pb-2">
                    Отчет ниже отражает вовлеченность компании и возможности для улучшения работы.
                </div>
                <div className="pb-2">
                    Период: <strong>Неделя {data.week}</strong>
                </div>
                <div className="pb-2">
                    Компания: <strong>{data.organizationName}</strong>
                </div>
                <div className="pb-2">
                    Временной охват: <strong>4 последние недели</strong>
                </div>
            </div>
            <br />
            <div className="a-report__text-block">
                <div className="font-size-18 font-weight-bold pb-2">Обращаем ваше внимание!</div>
                <div className="pb-3">
                    Представленная информация актуальна на момент формирования письма и формируется на основе данных:
                </div>
                <div>На корректность данных влияют:</div>
                <div>
                    <ul>
                        <li>Отчет о своевременном создании заявок</li>
                        <li>Список текущих заявок</li>
                        <li>Отчет по использованию приложения водителями</li>
                        <li>Активность пользователей</li>
                    </ul>
                </div>
            </div>
            <br />
            <div className="a-report__text-block no-page-break">
                <div className="a-report__text-link pb-3 font-size-18">По компании</div>
                {renderDataTable(data.mainData, true)}
            </div>
            <br />
            {data.logistsData.map((logistData, i) => (
                <div key={i} className="a-report__text-block no-page-break mb-3">
                    {i === 0 && <div className="a-report__text-link pb-3 font-size-18">По группам</div>}
                    <div>
                        <div className="font-weight-bold pb-1">{logistData.key}</div>
                        {renderDataTable(logistData.value)}
                    </div>
                </div>
            ))}
        </div>
    );
}
